import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './AuthContext';
import LandingPage from './pages/LandingPage';
import ProductPage from './pages/ProductPage';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import MVP from './pages/MVP';
import './App.css';

// Protected Route component
function ProtectedRoute({ children }) {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  return children;
}

// Redirect if already authenticated
function RedirectIfAuth({ children }) {
  const { currentUser } = useAuth();
  
  if (currentUser) {
    return <Navigate to="/product" />;
  }
  
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route 
        path="/product" 
        element={
          <ProtectedRoute>
            <ProductPage />
          </ProtectedRoute>
        } 
      />
      <Route path="/mvp" element={<MVP />} />
      <Route 
        path="/login" 
        element={
          <RedirectIfAuth>
            <LoginPage />
          </RedirectIfAuth>
        } 
      />
      <Route 
        path="/signup" 
        element={
          <RedirectIfAuth>
            <SignUpPage />
          </RedirectIfAuth>
        } 
      />
    </Routes>
  );
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <div className="App">
          <AppRoutes />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
